/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planner_SlotsInputs */

const en_planner_slots = /** @type {(inputs: Planner_SlotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meals`)
};

const de_planner_slots = /** @type {(inputs: Planner_SlotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mahlzeiten`)
};

/**
* | output |
* | --- |
* | "Meals" |
*
* @param {Planner_SlotsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const planner_slots = /** @type {((inputs?: Planner_SlotsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planner_SlotsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_planner_slots(inputs)
	return en_planner_slots(inputs)
});